import { Box } from "@mui/material";
import { useMedia } from "@local/theme";
// types
import type { ImgHTMLAttributes } from "react";
import type { Theme, SxProps } from "@mui/material/styles";

type Props = Readonly<ImgHTMLAttributes<HTMLImageElement> & {
	src: string;
	size?: number;
	sx?: SxProps<Theme>;
}>;

const Image = ({ src, title = undefined, alt = undefined, size = undefined, sx = undefined, ...other }: Props) => {
	const { getMediaPath } = useMedia();

	return (
		<Box
			component="img"
			src={src.startsWith("http") ? src : getMediaPath(src)}
			title={title}
			alt={alt ?? title}
			sx={{ width: size, height: size, verticalAlign: "middle", ...sx }} // eslint-disable-line @typescript-eslint/no-misused-spread
			{...other}
		/>
	);
};

export default Image;
